"use client";
import ModalForm from "@/components/Modal/Modal";
import Image from "next/image";
import { useState } from "react";
import RichText from "../RichText";

interface HeroBlockCustomProps {
  image: { url: string; alt?: string } | string; // Підтримка об’єкта з Payload або рядка
  color?: "violet" | "green" | "blue";
  title: any; // richText від Payload (JSON)
  subtitle: any; // richText від Payload (JSON)
  CTA_title?: any; // richText від Payload (JSON)
  CTA_btn?: string;
  CTA_tag?: string;
}

export default function HeroBlockWithImage({
  image,
  title,
  subtitle,
  CTA_btn = "Консультація",
  CTA_tag = "website",
  CTA_title = [{ children: [{ text: "Отримати детальнішу інформацію" }] }], // Значення за замовчуванням у форматі richText
  color = "green",
}: HeroBlockCustomProps) {
  const [isFormOpen, setIsFormOpen] = useState(false);

  const backgroundColorClass =
    {
      green: "custom-gradient-green-btn",
      blue: "custom-gradient-blue-btn",
      violet: "custom-gradient-violet-btn",
    }[color] || "custom-gradient-green-btn";

  // Обробка зображення: витягуємо URL, якщо це об’єкт із Payload
  const imageUrl = typeof image === "string" ? image : image?.url || "";

  const openForm = () => setIsFormOpen(true);
  const closeForm = () => setIsFormOpen(false);

  return (
    <>
      <div
        data-meta="HeroBlockWithImage"
        className="relative container mx-auto px-4 sm:px-6 lg:px-8 mb-8 sm:mb-14"
      >
        <div className="sm:px-6 lg:mt-12 lg:px-8">
          <div className="relative">
            <div className="flex lg:hidden text-center relative flex-col justify-end py-6 pb-16">
              <div className="text-2xl font-bold text-white sm:text-6xl rich-text-container">
                <RichText data={title} />
              </div>
              <div className="mt-2 max-sm:text-sm text-white rich-text-container">
                <RichText data={subtitle} />
              </div>
            </div>
            <Image
              width={1680}
              height={700}
              src={imageUrl}
              alt={typeof image === "object" && image.alt ? image.alt : ""}
              className="object-cover w-full h-full mask-second large"
            />
            <div className="hidden lg:flex absolute top-0 right-0 left-0 bottom-[15%] flex-col justify-end p-8">
              <div className="text-3xl font-bold text-white sm:text-6xl rich-text-container">
                <RichText data={title} />
              </div>
              <div className="mt-2 text-white rich-text-container">
                <RichText data={subtitle} />
              </div>
            </div>
            <div className="hidden lg:block absolute top-[90%] right-0">
              <div className="flex md:gap-2 xl:gap-12 items-center">
                <div className="text-white text-xs md:text-sm xl:text-base rich-text-container">
                  <RichText data={CTA_title} />
                </div>
                <button
                  onClick={openForm}
                  className={`uppercase ${backgroundColorClass} rounded-full px-8 py-2.5 text-center text-sm font-fixel font-bold text-white shadow-sm focus-visible:outline`}
                >
                  {CTA_btn}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="lg:hidden mt-4 font-fixel py-4 text-white text-md rounded-3xl flex flex-col justify-center items-center gap-4">
          <div className="text-white rich-text-container">
            <RichText data={CTA_title} />
          </div>
          <button
            onClick={openForm}
            className={`${backgroundColorClass} uppercase text-white rounded-full px-8 py-2.5 text-center text-sm font-fixel font-bold focus-visible:outline`}
          >
            {CTA_btn}
          </button>
        </div>
      </div>

      {isFormOpen && (
        <ModalForm
          closeForm={closeForm}
          btnMeta={{
            tag: CTA_tag,
          }}
          color={color}
        />
      )}
    </>
  );
}
